import React, { useEffect, useRef } from "react";
import katex from "katex";
import "katex/dist/katex.min.css";

/**
 * Renders text that may contain inline $...$ or $$...$$ LaTeX segments.
 */
export default function LatexText({ children, className }) {
  const ref = useRef(null);
  const text = children ?? "";

  useEffect(() => {
    if (!ref.current) return;
    // Split by $$...$$ (display) then $...$ (inline)
    const nodes = [];
    let remaining = text;
    // Alternate: handle display first
    const regex = /(\$\$[^$]+\$\$|\$[^$]+\$)/g;
    let lastIndex = 0;
    let match;
    while ((match = regex.exec(text)) !== null) {
      if (match.index > lastIndex) nodes.push({ type: "text", value: text.slice(lastIndex, match.index) });
      const raw = match[0];
      const isDisplay = raw.startsWith("$$");
      const src = raw.slice(isDisplay ? 2 : 1, raw.length - (isDisplay ? 2 : 1));
      nodes.push({ type: "latex", value: src, display: isDisplay });
      lastIndex = match.index + raw.length;
    }
    if (lastIndex < text.length) nodes.push({ type: "text", value: text.slice(lastIndex) });

    ref.current.innerHTML = "";
    nodes.forEach((n) => {
      if (n.type === "text") {
        ref.current.appendChild(document.createTextNode(n.value));
      } else {
        const span = document.createElement("span");
        try {
          katex.render(n.value, span, { throwOnError: false, displayMode: n.display });
        } catch {
          span.textContent = n.value;
        }
        ref.current.appendChild(span);
      }
    });
  }, [text]);

  return <span ref={ref} className={className} />;
}
